module.exports = __webpack_public_path__ + "img/error.e5461703.svg";